import Head from 'next/head';
import React from 'react';

import { InternCanonical } from '../../../models/intern/canonical';
import { useLinkProps } from '../../hooks/useLinkProps';

interface CanonicalProps {
  node: InternCanonical;
  fallbackUrl: string;
}

const clean = (href: string) => {
  const url = new URL(href);
  return url.origin + url.pathname;
};

export const Canonical: React.FC<CanonicalProps> = ({ node, fallbackUrl }) => {
  const { singleProps } = useLinkProps(node?.link[0]);
  const hasCanonical = !!singleProps?.href;

  return (
    <Head>
      <link rel="canonical" href={hasCanonical ? clean(singleProps.href) : fallbackUrl} key="canonical" />
    </Head>
  );
};
